import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "statistics-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayersReport = _resolveComponent("PlayersReport")!
  const _component_TopList = _resolveComponent("TopList")!
  const _component_StatisticsList = _resolveComponent("StatisticsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPlayersReportAllowed)
      ? (_openBlock(), _createBlock(_component_PlayersReport, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.isTopListAllowed)
      ? (_openBlock(), _createBlock(_component_TopList, { key: 1 }))
      : _createCommentVNode("v-if", true),
    (_ctx.isStatisticsListAllowed)
      ? (_openBlock(), _createBlock(_component_StatisticsList, { key: 2 }))
      : _createCommentVNode("v-if", true)
  ]))
}